import Stack from '@mui/material/Stack';
import { StyledLeftAlignedStack, StyledRightAlignedStack } from './styles';
import { forwardRef, Fragment } from 'react';

type Props = {
  leftAlignedActions?: React.ReactNode[];
  rightAlignedActions?: React.ReactNode[];
};

const Actions = forwardRef<HTMLDivElement, Props>(
  ({ leftAlignedActions, rightAlignedActions }, ref) => {
    return (
      <Stack
        ref={ref}
        direction="row"
      >
        {leftAlignedActions && leftAlignedActions.length > 0 && (
          <StyledLeftAlignedStack direction="row">
            {leftAlignedActions.map((action, index) => (
              <Fragment key={index}>{action}</Fragment>
            ))}
          </StyledLeftAlignedStack>
        )}
        {rightAlignedActions && rightAlignedActions.length > 0 && (
          <StyledRightAlignedStack direction="row">
            {rightAlignedActions.map((action, index) => (
              <Fragment key={index}>{action}</Fragment>
            ))}
          </StyledRightAlignedStack>
        )}
      </Stack>
    );
  },
);

Actions.displayName = 'SearchWidget.Actions';

export default Actions;
